var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-pdf_svg__clip0)",
    fill: "#E94848"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.641 8.175c-.133-.05-.224.019-.224.114v4.008c0 .155.126.227.297.169a2.25 2.25 0 00-.073-4.29zM4.333 8.082h-.75a.166.166 0 00-.166.166v1.501a.166.166 0 00.166.166h.75a.917.917 0 100-1.833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 0H1a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V1a1 1 0 00-1-1zM4.333 10.749h-.75a.166.166 0 00-.166.166V13a.417.417 0 11-.834 0V7.667A.417.417 0 013 7.25h1.333a1.75 1.75 0 110 3.5v-.001zM7 13.415A.417.417 0 016.583 13V7.665A.417.417 0 017 7.25a3.083 3.083 0 010 6.166zm6.667-5.333H12a.585.585 0 00-.583.583V9.75a.166.166 0 00.166.166h1.084a.416.416 0 110 .834h-1.084a.166.166 0 00-.166.166V13a.416.416 0 11-.834 0V8.667A1.418 1.418 0 0112 7.249h1.667a.417.417 0 110 .833z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-pdf_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgIconPdf;